module.exports = __webpack_public_path__ + "img/location-confirm.96aad970.jpg";